import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_PADDING,CSS_PADDING_COMPACT,CSS_COLOR_RED,CSS_COLOR_ACTION,CSS_COLOR_BORDERS,CSS_INPUT_RADIUS, IFRAME_MODE, IFRAME_MODE_TOP_DOMAIN} from '../constants';
import {ralToText} from '../helpers';
import Selector from './EditorSelector';
import { useState, useEffect, useRef } from "react";
import Scrolldown from './Scrolldown';


import arrow_black_svg from '../assets/arrow_black.svg';
import arrow_select_svg from '../assets/arrow_select.svg';
import checked_svg from '../assets/checked.svg';


const AskerStyled = styled.div`
h2 {
	font-weight: 700;
	font-size: 26px;
	color: #555555;
	padding: ${CSS_PADDING};
	border-bottom: 1px solid ${CSS_COLOR_BORDERS};
	text-align: center;
}
p {
	margin-bottom: ${CSS_PADDING};
	text-align: center;
}
.form-holder {
	padding: ${CSS_PADDING_COMPACT};
}
form {
	border: 1px solid ${CSS_COLOR_BORDERS};
	margin-bottom: ${CSS_PADDING_COMPACT};
	padding: 13px 13px 9px;
	background: #fff;
	border-radius: 10px;
	h3,.checkbox-holder label {
		font-size: 18px;
		margin-bottom: 16px;
		font-weight: 700;
	}
	.bloc-holder {
		border: 1px solid ${CSS_COLOR_BORDERS};
		border-radius: ${CSS_INPUT_RADIUS};
		padding: ${CSS_PADDING_COMPACT} ${CSS_PADDING_COMPACT} 5px;
		margin: 15px 0;
		.label-holder {
			input,select,textarea {
				width: 279px;
			}
			label {
				right: 289px;
			}
		}
	}
	.checkbox-holder {
		margin: 15px 0;
		display: flex;
		align-items: center;
		cursor: pointer;
		label {
			flex: 1 1 auto;
			text-align: right;
			font-size: 19px;
			font-weight: bold;
			cursor: pointer;
			margin: 0;
		}
		&.error label {
			color: ${CSS_COLOR_RED};
		}
		.arrow,.checkbox {
			box-sizing: border-box;
			width: 40px;
			height: 40px;
			margin-left: 6px;
			flex: 0 0 auto;
			background-position: 50% 50%;
			background-repeat: no-repeat;
		}
		.arrow {
			background-image: url(${arrow_black_svg});
		}
		.checkbox {
			border-radius: 4px;
			border: 2px solid ${CSS_COLOR_ACTION};
			&.checked {
				background-image: url(${checked_svg});
			}
			&:hover {
				background-color: #f1f1f1;
			}
		}
	}
	.privacy-policy-intro {
		margin-top: 15px;
		b {
			white-space: nowrap;
		}
	}
	.privacy-policy-showmore {
		cursor: pointer;
		u {
			color: ${CSS_COLOR_ACTION};
		}
	}
	.privacy-policy-holder {
		display: none;
		&.show {
			display: block;
		}
		border: 1px solid ${CSS_COLOR_BORDERS};
		border-radius: ${CSS_INPUT_RADIUS};
		padding: ${CSS_PADDING_COMPACT} ${CSS_PADDING_COMPACT} 5px;
		margin: 5px 0;
		background-color: #fff;
		* {
			text-align: left;
		}
		h2 {
			margin-top: 0;
			padding-top: 0;
		}
		a {
			color: ${CSS_COLOR_ACTION};
			white-space: nowrap;
		}
		ul {
			margin-left: 20px;
		}
		p {
			margin-top: 10px;
		}
	}
	.label-holder {
		margin-bottom: 6px;
		position: relative;
		height: 40px;
		&.high {
			height: 78px;
		}
		&.unvalid {
			label {
				font-weight: 700;
				color: ${CSS_COLOR_RED};
			}
		}
		label {
			position: absolute;
			top: 0;
			left: 0;
			right: 300px;
			text-align: right;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			display: block;
			line-height: 40px;
			&.dualline {
				line-height: 18px;
				padding-top: 2px;
				padding-bottom: 2px;
			}
		}
		input,select,textarea {
			background-color: #fff;
			color: #222;
			margin-bottom: 0;
			box-sizing: border-box;
			width: 100%;
			font-size: 18px;
			resize: none;
			position: absolute;
			height: 40px;
			display: inline-block;
			width: 290px;
			top: 0;
			right: 0;
			border-radius: ${CSS_INPUT_RADIUS};
			border: 1px solid ${CSS_COLOR_BORDERS};
		}
		select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			padding-right: 27px;
			padding-left: 10px;
			text-indent: .01px;
			background-image: url(${arrow_select_svg});
			background-repeat: no-repeat;
			background-position: right;
			text-align: left;
			font-size: 14px;
			font-weight: 500;
		}
		textarea {
			height: 78px;
		}
		input {
			line-height: 38px;
		}
	}
}
@media ${CSS_MOBILE_BREAKPOINT}{
	form {
		max-width: 500px;
		margin-left: auto;
		margin-right: auto;
		.label-holder {
			height: auto !important;
			input,select,textarea {
				position: static !important;
				width: 100% !important;
			}
			label {
				display: block;
				width: auto !important;
				margin-bottom: 5px;
				position: static !important;
				text-align: left;
			}
		}
	}
}
`;

function AskerInput({name,label,value="",placeholder="",error=false,onChange,id}){
	function change(e){
		onChange(id,e.target.value);
	}
	return <div className={"label-holder"+(error?' unvalid':'')}>
		<label>{label} :</label>
		<input type="text" name={name} value={value} onChange={change} placeholder={placeholder} />
	</div>
}

function Asker({selected_values,computed_objects,onEnd}) {


	const container_ref = useRef(null);
	const [step,setStep] = useState(0);
	const [rgpd_accepted,setRGPD] = useState(!IFRAME_MODE);
	const [rgpd_error,setRGPDError] = useState(false);
	const [invoicing_and_delivery_identical,setIADI] = useState(false);
	const [inputs,setInputs] = useState([
		// label				name				placeholder			value	mandatory	error
		['Prénom',				'given-name',		'Jean-Pierre',			'',	true,		false],
		['Nom',					'family-name',		'Goulard',				'',	true,		false],
		['Société (facultatif)','organization',		'',						'',	false,		false],
		['N° de TVA (facultatif)','vat',			'',						'',	false,		false],
		['N° de SIRET (facultatif)','siret',		'',						'',	false,		false],
		['Email',				'email',			'jp.goulard@gmail.com',	'',	true,		false],
		['Téléphone',			'tel',				'0600000000',			'',	true,		false],

		['N° et rue',			'address',			'6 rue des Vignettes',	'',	true,		false],
		['Code postal',			'postal-code',		'78770',				'',	true,		false],
		['Commune',				'city',				'Thoiry',				'',	true,		false],
		['Pays',				'country',			'France',				'',	true,		false],

		['N° et rue',			'address-invoice',			'',				'',	true,		false],
		['Code postal',			'postal-code-invoice',		'',				'',	true,		false],
		['Commune',				'city-invoice',				'',				'',	true,		false],
		['Pays',				'country-invoice',			'',				'',	true,		false],


		['Vous nous connaissez...',		'acquisition',		'',				(IFRAME_MODE_TOP_DOMAIN?('site-'+IFRAME_MODE_TOP_DOMAIN):'unknow'),	true,		false],
		['Remarques facultatives',		'notes',			'',				'',	false,		false],
	]);


	function getInput(id){
		const input = inputs[id];
		return {
			label:			input[0],
			name:			input[1],
			placeholder:	input[2],
			value:			input[3],
			mandatory:		input[4],
			error:			input[5]
		}
	}
	function changeInput(id,value){
		setInputs((inputs)=>{
			const new_inputs = inputs.slice();
			new_inputs[id][3] = value;
			return new_inputs;
		});
	}

	function makeAskerInput(id){
		const input = getInput(id);
		return <AskerInput
			label={input.label}
			name={input.name}
			placeholder={input.placeholder}
			value={input.value}
			error={input.error}
			id={id}
			onChange={changeInput}
		/>;
	}
	const email = getInput(5).value;


	function hasError(id){
		const input = getInput(id);
		if(input.mandatory){
			if(invoicing_and_delivery_identical && input.name.indexOf('-invoice') > -1){
				return false;
			}
			if(input.name === 'email'){
				var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				return !re.test(input.value);
			}
			if(input.name === 'acquisition' && input.value === 'unknow'){
				return true;
			}
			if(input.value.length < 2){
				return true;
			}
		}
		return false;
	}
	function setErrors(){
		let has_errors = false;
		const new_inputs = inputs.slice();
		new_inputs.forEach((input,input_id)=>{
			input[5] = hasError(input_id);
			if(input[5]){
				has_errors = true;
			}
		});
		setInputs(new_inputs);
		return has_errors;
	}
	function userFromInputs(){
		const user = {
			invoicing_and_delivery_identical: invoicing_and_delivery_identical
		};
		inputs.forEach((item, i) => {
			user[item[1]] = item[3];
		});
		return user;
	}
	function doSubmit(){
		const abri_package_infos = computed_objects.abri_package_infos;
		var request = {
			user: userFromInputs(),
			share_link: computed_objects.share_link,
			ids: abri_package_infos.components,
			total_price: abri_package_infos.total_price,
			total_mass: abri_package_infos.total_mass,
			colors: {
				toiture: ralToText(selected_values.color_roof),
				bardage: ralToText(selected_values.color_walls),
				accessoires: ralToText(selected_values.color_accessories)
			},
			darwin: Math.round((abri_package_infos.total_price*3+abri_package_infos.total_mass*5)*16823),
			delivery: !!selected_values.delivery
		};
		fetch(
			'./mail-api.php',
			{
				method: 'POST',
				body: JSON.stringify(request)
			}
		)
		.then((response) => response.text())
		.then((quote_number)=>{
			quote_number && window.gtag && window.gtag('event','quotation',{
				'event_category': 'general',
				'event_label': quote_number
			});
			//gtag('event', 'conversion', {'send_to': 'AW-761764946/8XZRCKjniZkBENK4nusC'});
		});
		setStep(1);
	}
	function trySubmit(){
		if(setErrors()){
			window.setTimeout(function(){
				alert('Merci de remplir correctement les champs indiqués en rouge afin de nous permettre d\'établir votre devis.');
			},30);
		}else if(!rgpd_accepted){
			setRGPDError(true);
			window.setTimeout(function(){
				alert('Merci d\'accepter notre politique de confidentialité afin de nous permettre d\'établir votre devis.');
			},30);
		}else{
			doSubmit();
		}
		if(container_ref.current){
			container_ref.current.scrollIntoView(true);
		}
	}
	function handleSubmit(e){
		e.preventDefault();
		trySubmit();
	}

	function handleClick(id,value){
		if(value){
			trySubmit();
		}else{
			onEnd();
		}
	}

	useEffect(()=>{
		if(container_ref.current){
			if(!IFRAME_MODE){
				container_ref.current.scrollIntoView(true);
			}else{
				container_ref.current.scrollIntoView();
			}
		}
		window.scrollTo(0,0);
	},[container_ref,step]);


	return (
		<AskerStyled ref={container_ref}>
			<h2>Demandez votre devis</h2>
			{step===0?<div className={'form-holder'}>
				<p>Veuillez remplir le formulaire ci-dessous pour recevoir gratuitement votre devis personnalisé par email. {(!IFRAME_MODE)&&<><br/>Vos données personnelles ne seront communiquées à aucun tiers.</>}</p>
<form action="./demande_devis.php" autoComplete="on" onSubmit={handleSubmit}>
{makeAskerInput(0)}
{makeAskerInput(1)}
{makeAskerInput(2)}
{makeAskerInput(3)}
{makeAskerInput(4)}
{makeAskerInput(5)}
{makeAskerInput(6)}
<div className="bloc-holder">
	<h3>Votre adresse de livraison :</h3>
	{makeAskerInput(7)}
	{makeAskerInput(8)}
	{makeAskerInput(9)}
	{makeAskerInput(10)}
</div>
<div className="checkbox-holder" onClick={()=>{setIADI((v)=>(!v))}}>
	<label>Si adresse de facturation identique cliquez <u>ici</u></label>
	<div className="arrow"></div>
	<div className={"checkbox "+(invoicing_and_delivery_identical?'checked':'unchecked')} id="invoice-address-checkbox"></div>
</div>
{(!invoicing_and_delivery_identical)&&<div className="bloc-holder">
	<h3>Votre adresse de facturation :</h3>
	{makeAskerInput(11)}
	{makeAskerInput(12)}
	{makeAskerInput(13)}
	{makeAskerInput(14)}
</div>}
{(!IFRAME_MODE)&&<div id="acquisition" className={"label-holder"+(getInput(15).error?' unvalid':'')}>
	<label className="dualline">Vous connaissez&nbsp;<br className="hide-sm"/>Abri-Tole.fr via :</label>
	<select name="acquisition" value={getInput(15).value} onChange={(e)=>{changeInput(15,e.target.value)}}>
		<option disabled="disabled" value="unknow">Veuillez sélectionner un choix</option>
		<option value="search">Une recherche sur Google / Bing</option>
		<option value="mailing">Un email que vous avez reçu</option>
		<option value="lbc">Leboncoin</option>
		<option value="facebook">Facebook</option>
		<option value="referral">Un site partenaire</option>
		<option value="display">Une publicité sur internet</option>
		<option value="magazine">Une publicité dans un magazine</option>
		<option value="ami">Le conseil d'un ami (merci !)</option>
		<option value="autre">Autre (précisez ci-dessous)</option>
	</select>
</div>}
<div className={"high label-holder"+(getInput(16).error?' unvalid':'')}>
	<label>Remarques facultatives :</label>
	<textarea value={getInput(16).value} onChange={(e)=>{changeInput(16,e.target.value)}}></textarea>
</div>
{(IFRAME_MODE)&&<>
<div className="privacy-policy-intro">
	<p>Vos coordonnées seront transmises à <b>Abri-Tole.fr / CECA 08</b> qui vous enverra votre devis.</p>
</div>
<div className={"checkbox-holder"+(rgpd_error?' error':'')} onClick={()=>{setRGPD((v)=>(!v))}}>
	<label>
		Pour accepter notre politique de confidentialité, cliquez <u>ici</u></label>
	<div className="arrow"></div>
	<div className={"checkbox "+(rgpd_accepted?'checked':'unchecked')} id="rgpd-checkbox"></div>
</div>
<div className="privacy-policy-showmore" onClick={()=>{document.querySelector('.privacy-policy-holder').classList.toggle('show');}}>
	<p>Pour consulter notre politique de confidentialité, <u>cliquez ici</u></p>
</div>
<div className="privacy-policy-holder">
	<h2>Politique de confidentialité</h2>
	<p>
	Les informations recueillies via ce formulaire sont destinées exclusivement au
	traitement de votre demande de devis.
	</p>
	<p>
	Les données personnelles collectées (nom, prénom, adresse e-mail, numéro de
	téléphone, adresse du projet et toute autre information fournie) sont
	transmises à <strong>Abri-Tole.fr / CECA 08</strong> afin de vous contacter et
	d'établir votre devis.
	</p>
	<p>
	Ces données ne sont utilisées à aucune autre fin sans votre consentement et ne
	sont pas cédées à des tiers, sauf obligation légale ou nécessité liée au
	traitement de votre demande.
	</p>
	<p>
	Les données sont conservées pendant la durée nécessaire au traitement de votre
	demande, puis supprimées ou archivées conformément aux obligations légales en
	vigueur.
	</p>
	<h3>Vos droits</h3>
	<p>
	Conformément au Règlement Général sur la Protection des Données (RGPD), vous
	disposez des droits suivants :
	</p>
	<ul>
		<li>Droit d'accès à vos données personnelles.</li>
		<li>Droit de rectification de vos données.</li>
		<li>Droit à l'effacement de vos données.</li>
		<li>Droit à la limitation du traitement.</li>
		<li>Droit d'opposition au traitement.</li>
		<li>Droit à la portabilité de vos données lorsque celui-ci est applicable.</li>
	</ul>
	<p>
	Pour exercer ces droits, vous pouvez contacter <strong>Abri-Tole.fr / CECA 08</strong> à l'adresse suivante : <a href="mailto:contact@abri-tole.fr">contact@abri-tole.fr</a>.
	</p>
	<p>
	Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire
	une réclamation auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.
	</p>
	<p>
	En cochant la case d'acceptation du formulaire, vous reconnaissez avoir pris
	connaissance de la présente politique de confidentialité et acceptez la
	transmission de vos coordonnées à <strong>Abri-Tole.fr / CECA 08</strong> pour le traitement de votre demande de
	devis.
	</p>
</div>
</>}
</form>
<Selector
	head_number={false}
	head_text={false}
	options={[{value:true,display:<>Demandez votre devis <u>cliquez ici</u></>},{value:false,display:<>Annulation</>}]}
	type={'buttons'}
	selected_id={'ask'}
	selected_value={true}
	disable_border={true}
	focus_status={'present'}
	onSelection={handleClick}
	auto_scroll={false}
/>
			</div>:<div className={'form-holder'}>
				<p>
					Votre demande a bien été envoyée.<br/>
					Vous recevrez votre devis dans votre boite email dans quelques instants.
				</p>
				<p>
					Si votre devis n'est pas arrivé après 5 minutes, merci de vérifier :<br/>
					- le contenu de votre dossier "spam" ou "courrier indésirable"<br/>
					- l'absence d'erreur de saisie dans l'adresse "<span id="email-span">{email}</span>"
				</p>
				<p>N'hesitez pas à nous contacter si votre devis ne vous parvient pas.</p>
				<Selector
					head_number={false}
					head_text={false}
					options={[{value:false,display:<>Retour à la configuration <u>cliquez ici</u></>}]}
					type={'buttons'}
					selected_id={'ask'}
					selected_value={true}
					disable_border={true}
					focus_status={'present'}
					onSelection={handleClick}
					auto_scroll={false}
					arrows={false}
				/>
			</div>}
			<Scrolldown/>
		</AskerStyled>
	);
}

export default Asker;
